interface CountryData {
  country: string;
  countryCode: string;
  count: number;
  percent: number;
}

interface CountryChartProps {
  data: CountryData[];
}

const FLAG_BASE = "https://flagcdn.com/24x18";

export default function CountryChart({ data }: CountryChartProps) {
  if (data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-[#3a5070]">
        <i className="ri-global-line text-5xl mb-3"></i>
        <p className="text-sm">暂无访客数据</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {data.map((item) => (
        <div key={item.countryCode} className="flex items-center gap-3">
          <img
            src={`${FLAG_BASE}/${item.countryCode.toLowerCase()}.png`}
            alt={item.country}
            className="w-6 h-[18px] rounded-sm object-cover shrink-0"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
          <span className="text-[#8aaec8] text-sm w-28 truncate shrink-0">{item.country}</span>
          <div className="flex-1 bg-[#0a1628] rounded-full h-2 overflow-hidden">
            <div
              className="h-full rounded-full bg-gradient-to-r from-[#4fc3f7] to-[#0288d1] transition-all duration-700"
              style={{ width: `${item.percent}%` }}
            />
          </div>
          <span className="text-white text-sm font-medium w-8 text-right shrink-0">{item.count}</span>
          <span className="text-[#5a7a9a] text-xs w-10 text-right shrink-0">{item.percent.toFixed(1)}%</span>
        </div>
      ))}
    </div>
  );
}
